import { post, get, deletefn, putfun } from './http.js'
export default {
  // 教学课程列表
  async courseList (params) {
    return await get ('/course',params)
  },
  // 视频详情
  async videoDetail (params) {
    return await get (`/course-details/${params}`)
  },
  // 内部视频详情
  async videoInsideDetail (params) {
    return await get (`/course-details/${params.id}`,params)
  },
  // 视频分类
  async videoCategory (params) {
    return await get ('/video-category',params)
  },
  // 视频标签
  async videoTag (params) {
    return await get ('/user/course-tag',params)
  },
  // 等级列表
  async videoLevelList (params) {
    return await get ('/user-level',params)
  },
  // 视频播放地址
  async videoPlayUrl (params) {
    return await get (`/course-video/${params}`)
  },
  // 提交观看时间
  async submitRecodeTime (params) {
    return await post (`/course-recode/${params.id}`,params)
  },
  // 评论列表
  async replyList (params) {
    return await get (`/course-reply/${params.id}`,params)
  },
  // 发布评论
  async submitReply (params) {
    return await post (`/course-reply/${params.id}`,params)
  },
  // 删除评论
  async replyDelete (params) {
    return await deletefn (`/course-reply/${params}`)
  },
  // // 附件列表
  async attachList (params) {
    return await get (`/course-attach/${params.id}`,params)
  },
  // 附件下载
  async attachDownload(params) {
    return await post (`/course-attach-download/${params}`)
  },
  // 附件下载记录
  async downloadAttach(params) {
    return await get ('/course-attach-download',params)
  },
  // 课程观看记录
  async courseVideoRecode(params) {
    return await get (`/course-video-recode/${params}`)
  },
  // 相似课程
  async courseSee(params) {
    return await get (`/similar-video/`,params)
  },
  /* 推荐课程 */
  async courseRec(params) {
    return await get (`/course-recommend/`,params)
  },
  // 提交课程
  async coursePost(params) {
    return await post ('user/course',params)
  },
  // 课程编辑
  async coursePut(params) {
    return await putfun (`/user/course/${params.id}`,params)
  },
  // 删除课程
  async courseDelete(params) {
    return await deletefn (`/user/course/${params}`)
  },
  // 发布课程列表/
  async courseMyList(params) {
    return await get ('user/course-my',params)
  },
  // 章节列表
  async chapterList(params) {
    return await get ('user/course-chapter',params)
  },
  // 章节新增
  async chapterAdd(params) {
    return await post ('user/course-chapter',params)
  },
  // 章节更新
  async chapterPut(params) {
    return await putfun (`user/course-chapter/${params.id}`,params)
  },
  // 章节删除
  async chapterDelete(params) {
    return await deletefn (`user/course-chapter/${params}`)
  },
  // 我的视频列表
  async userVideoList(params) {
    return await get (`user/course-video`,params)
  },
  // 我的视频 新增
  async userVideoAdd(params) {
    return await post (`user/course-video`,params)
  },
  // 我的视频修改
  async userVideoPut(params) {
    return await putfun (`user/course-video/${params.id}`,params)
  },
  // 我的视频删除
  async userVideoDelete(params) {
    return await deletefn ('user/course-video',params)
  },
  // 我的附件列表
  async videoAttachList(params) {
    return await get ('user/course-attach',params)
  },
  // 我的附件 新增
  async videoAttachAdd(params) {
    return await post ('user/course-attach',params)
  },
  // 我的附件修改
  async videoAttachPut(params) {
    return await putfun (`user/course-attach/${params.id}`,params)
  },
  // 我的附件删除
  async videoAttachDelete(params) {
    return await deletefn (`user/course-attach/${params}`)
  },
  // 礼物列表
  async video_gift(params) {
    return await get ('gift')
  },
  // 礼物打赏
  async video_gift_post(params) {
    return await post (`video-reward/${params.id}`,params)
  },
  // 礼物打赏记录
  async video_gift_record(params) {
    return await get (`course-video-gift/${params.id}`,params)
  },
  /* 笔记提交 */
  async video_note_post(params) {
    return await post (`video-note`,params)
  },
  /* 笔记列表 */
  async video_note_list(params) {
    return await get (`video-note`,params)
  },
  /* 更新笔记 */
  async video_note_put(params) {
    return await putfun (`video-note/${params.id}`,params)
  },
  /* 删除我的笔记 */
  async video_note_delete(data) {
    return await deletefn (`video-note/${data}`)
  },
  /* 弹幕列表 */
  async video_barrage_list(data) {
    return await get (`video-barrage/${data}`)
  },
  /* 发送弹幕 */
  async video_barrage_post(params) {
    return await post (`video-barrage/${params.id}`,params)
  },
  /* 随机广告 */
  async advert_info(params){
    return await get (`/common/advert-random`,params)
  },
  /* 视频广告点击数 */
  async advert_detail(id,params){
    return await putfun (`/common/advert/${id}`,params)
  }
}



// WEBPACK FOOTER //
// ./src/request/video.js